export default [
    {
        path: '/student-daily-activities',
        name: 'student-daily-activities',
        meta: { requiresAuth: true },
        component: () => import('@/pages/student-daily-activity/index.vue'),
        beforeEnter: async (to, from, next) => {
            next()
        }
    },
]
